const webImgPath = "/images/projects/web/";
const gamesImgPath = "/images/projects/games/";
const animImgPath = "/images/projects/animations/";

export const dataStore = {
  web: {
    tools: [
      "javascript",
      "react",
      "redux",
      "mongodb",
      "mongoose",
      "express",
      "nodejs",
      "rest api",
      "jwt",
      "sass",
      "gsap",
      "figma",
    ],
    projects: [
      {
        name: "playanime",
        desc: "Playanime is an anime streaming platform that boasts a vast collection of anime series that caters to all tastes. Whether you prefer action, romance, comedy, or horror, you can find it all on playanime.",
        demo: "https://play-anime.vercel.app/",
        code: "https://github.com/avi-spc/playanime",
        image: `${webImgPath}playanime.png`,
      },
      {
        name: "nudge",
        desc: "Nudge is an image sharing social networking service that allows users to upload media and share it with their peers.",
        demo: "https://nudge.vercel.app/",
        code: "https://github.com/avi-spc/nudge",
        image: `${webImgPath}nudge.png`,
      },
      {
        name: "academia",
        desc: "Platform developed for educational institutions that aims for creating, distributing and grading assignments streamlining the process between professors and their pupils.",
        demo: "https://academia-omega.vercel.app/",
        code: "https://github.com/avi-spc/academia",
        image: `${webImgPath}academia.png`,
      },
      {
        name: "drone simulator",
        desc: "Simulation platform to imitate and track drone’s movement on the world map based on chronological data of latitudes and longitudes from real life.",
        demo: "https://drone-simulator.vercel.app/",
        code: "https://github.com/avi-spc/drone-simulator",
        image: `${webImgPath}nudge.png`,
      },
    ],
  },
  games: {
    tools: [
      "unity engine",
      "visual studio",
      "blender",
      "audacity",
      "adobe illustrator",
    ],
    projects: [
      {
        name: "avsaka",
        desc: "The game is about a hero who is trying to restore his own planet which has been looted and destroyed by his enemies. He invades different planets, fights enemies, collect valuable resources and bring back to his planet named as Avsaka to restore as it was before.",
        demo: "https://www.microsoft.com/en-in/p/avsaka/9ph3srphgc22?rtc=1&activetab=pivot:overviewtab",
        code: "https://github.com/avi-spc/Save-Avsaka",
        image: `${gamesImgPath}avsaka.png`,
      },
      {
        name: "battlearena",
        desc: "An online multiplayer experience built upon Photon Unity Networking framework where players can host lobbies and friends can join the arena to battle with each-other.",
        demo: "https://avi-spc.itch.io/battlearena",
        code: "https://github.com/avi-spc/BattleArena_CN",
        image: `${gamesImgPath}battlearena.png`,
      },
      {
        name: "saladchef",
        desc: "A 2D restaurant simulation game included with local multiplayer where two players compete with eachother and tries to serve and make customers more happy by providing fast and precise salad orders.",
        demo: "https://avi-spc.itch.io/saladchef",
        code: "https://github.com/avi-spc/saladchef",
        image: `${gamesImgPath}saladchef.png`,
      },
    ],
  },
  animations: {
    tools: [
      "3dsmax",
      "adobe photoshop",
      "adobe illustrator",
      "adobe animate",
      "adobe after effects",
      "arnold renderer",
    ],
    projects: [
      {
        name: "creativekonami",
        desc: "Sublime professional design portfolio website showcasing design and animation potential.",
        demo: "https://creativekonami.vercel.app/",
        code: "https://github.com/avi-spc/creativekonami-website",
        image: `${animImgPath}creativekonami.png`,
      },
    ],
  },
};
